Grid = {
    init() {
        const grid = document.getElementById('grid');

        if (grid) {
            var pckry = new Packery('.grid', {
                itemSelector: '.grid-item',
                gutter: 20
            });
        }
    }
}

export let Grid;